export default __webpack_public_path__ + "static/preview-96747db4e9e99f862d17888ccb39f43e.jpg";